module.exports = __webpack_public_path__ + "img/gongsijianjie.e409a28e.webp";